module.exports = __webpack_public_path__ + "img/stamp-insect-jul.d78e1c3a.png";